import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import VisitDetailPage from "../VisitDetailPage/VisitDetailPage";
import MonitorVisitDetail from "../Monitor/MonitorVisitDetail/MonitorVisitDetail";
import ParentVisitDetailPage from "./ParentVisitDetailPage";
import { Text } from "../../design/text";

/**
 * Role-based visit detail page that renders different content based on user role
 *
 * - Admin: Full visit details with edit capabilities, scheduling, cancellation, deletion
 * - Supervisor/Monitor: Visit details with ability to add events and update status (no edit/delete)
 * - Parent: Simplified view with only date, time, location, and monitor info
 */
const RoleBasedVisitDetail: React.FC = () => {
  const { role, isAdmin, isMonitor, isParent, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Text>Loading...</Text>
      </div>
    );
  }

  // Admin sees the full visit detail page with all edit capabilities
  if (isAdmin) {
    return <VisitDetailPage />;
  }

  // Supervisors/Monitors see a view with event recording and status updates
  if (isMonitor) {
    return <MonitorVisitDetail />;
  }

  // Parents see a simplified view
  if (isParent) {
    return <ParentVisitDetailPage />;
  }

  // Fallback for unknown roles
  return (
    <div className="flex items-center justify-center h-64">
      <Text className="text-zinc-500">Unknown role: {role}</Text>
    </div>
  );
};

export default RoleBasedVisitDetail;
